import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { DateService } from "@services/date.service";
import { ReeferZoneOperatingModeCategory } from "@temperature/_enums/reefer/ReeferZoneOperatingModeCategory.enum";
import { IMultiStateInputRecord } from "@temperature/_models/multiStateInputs/IMultiStateInputRecord";
import { IZoneWithProbes } from "@temperature/_models/temperature/ITemperatureZone";
import { ZoneService } from "@temperature/_services/zone.service";
import './zone-operating-mode-widget.component.scss';

@Component({
    selector: 'zone-operating-mode-widget',
    template: require('./zone-operating-mode-widget.component.html')
})
export class ZoneOperatingModeWidget implements OnChanges {
    @Input() category: ReeferZoneOperatingModeCategory;
    @Input() showText: boolean;
    @Input() zones: IZoneWithProbes[];
    @Input() zonePosition: number;
    @Input() record: IMultiStateInputRecord;

    // ---

    displayText: string;
    tooltip: string;

    className: string;
    icon: string;

    constructor(
        private readonly zoneService: ZoneService,
        private readonly dateService: DateService
    ) {
    }

    ngOnInit(): void {
        this.render();
    }
    ngOnChanges(changes: SimpleChanges): void {
        this.render();
    }

    // ---

    private render(): void {
        this.reset();

        if (typeof this.zones === "string") {
            return;
        }

        if (!ReeferZoneOperatingModeCategory[this.category]) {
            this.updateCategory();
        }

        this.updateDisplayText();
        this.updateClassName();
        this.updateIcon();
    }

    private reset(): void {
        this.displayText = null;
        this.className = null;
        this.icon = null;
    }

    private updateCategory(): void {
        if (!this.zones && this.category) {
            return;
        }

        this.category = this.zoneService.getZoneAtPosition(this.zones, this.zonePosition)?.operatingMode;
    }

    private updateClassName(): void {
        this.className = this.zoneService.getOperatingModeColourClass(this.category);
    }

    private updateIcon(): void {        
        this.icon = this.zoneService.getOperatingModeIcon(this.category);
    }

    private updateDisplayText(): void {
        this.displayText = this.zoneService.getOperatingModeTranslation(this.category);

        if (this.record) {
            this.tooltip = this.dateService.formatDate(this.record.EventTime, { dateTime: true });
        }
    }
}
